<template>
  <div class="h-100">
    <v-alert
      v-if="errors_exist"
      dismissible
      type="error"
      class="rounded-0"
    >
      {{ $vuetify.lang.t('$vuetify.msg.hasError') }}
      <ul v-if="errors">
        <div v-for="(error, index) in errors"
          :key="index">
          <li>{{ error[0] }}</li>
        </div>
      </ul>
    </v-alert>
    <v-alert
      v-if="success"
      dismissible
      class="rounded-0"
      type="success"
    >
      Gửi phản hồi thành công!
    </v-alert>
    <v-card flat class="h-100">
      <v-toolbar dense flat>
        <v-toolbar-title>
          Liên hệ - Phản hồi
        </v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle 
        v-if="!isValid"
        class="red--text"
      >
        <strong>Lưu ý:</strong> Vui lòng điền đầy đủ các thông tin có kèm theo dấu (*)
      </v-card-subtitle>
      <v-card-text>
        <v-form
          v-model="isValid" 
          @submit.prevent="send"
          ref="contactForm"
        >
          <v-row>
            <v-col cols="12" sm="12" md="4">
              <v-text-field 
                v-model="form.name"
                label="Tên"
                class="require"
                :rules="[v => !!v]"
                outlined
                dense
                hide-details
              />
            </v-col>
            <v-col cols="12" sm="12" md="4">
              <v-text-field 
                v-model="form.email"
                label="E-Mail" 
                outlined
                dense
                hide-details
              />
            </v-col>
            <v-col cols="12" sm="12" md="4">
              <v-text-field 
                v-model="form.phone"
                label="Số điện thoại" 
                class="require" 
                :rules="[v => !!v]"
                outlined
                dense
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-text-field 
                v-model="form.title"
                label="Tiêu đề"
                class="require" 
                :rules="[v => !!v]"
                outlined
                dense
                hide-details
              />
            </v-col>
            <v-col cols="12" class="text-left">
              <label class="require">Nội dung</label>
              <quill-editor 
                v-model="form.message"
                :options="editorOption"
                :rules="[v => !!v]"
                style="min-height:150px;"
                class="mt-2"
              >
              </quill-editor>
            </v-col>
            <v-col cols="12">
              <label>Đính kèm hình ảnh</label>
              <vue-dropzone 
                ref="myVueDropzone" 
                id="dropzone" 
                class="dropzone-custom-border"
                :options="dropzoneOptions"
                :destroyDropzone="false"
                v-on:vdropzone-success="uploadSuccess"
                v-on:vdropzone-error="uploadError"
                v-on:vdropzone-removed-file="fileRemoved"
                @vdropzone-mounted="loadPictures"
              />
              <div class="red--text text-center">
                Lưu ý: Chỉ chấp nhận tập tin dạng: *.jpg, *.jpeg, *.png và kích thước <= 2MB
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="text-center">
              <v-btn 
                tile
                class="mr-2 px-10"
                color="primary"
                @click="resetForm"
              >
                <v-icon class="mr-2">
                  mdi-sync
                </v-icon>
                Làm mới
              </v-btn>
              <v-btn 
                v-show="isValid"
                tile
                class="mt-2 mb-2 px-10" 
                color="primary"
                type="submit" 
                :loading="loading"
                :disabled="!isValid"
              >
                <v-icon class="mr-2">
                  mdi-email-fast-outline
                </v-icon>
                Gửi đi
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
  import vue2Dropzone from 'vue2-dropzone';
  import 'vue2-dropzone/dist/vue2Dropzone.min.css';
  import { mapState, mapActions } from 'vuex';
  export default {
    name: "home",
    components: { 
      vueDropzone: vue2Dropzone,
    },
    data() {
      return {
        form: {
          name: null,
          email: null,
          phone: null,
          title: null,
          message: null,
          images: []
        },
        loading: false,
        errors_exist: false,
        errors: [],
        success: false,
        images: [],
        isValid: true,
        dropzoneOptions: {
          url: null,
          addRemoveLinks: true,
          dictRemoveFile: "×",
          removeType: "server",
          dictDefaultMessage: "<i class='mdi mdi-24px mdi-arrow-collapse-up'></i> <div>Tải lên hình ảnh</div>",
          acceptedFiles: "image/jpeg,image/png,image/jpg",
          thumbnailWidth: 100,
          thumbnailHeight: 100,
          headers: {
            "Cache-Control": null, 
            "X-Requested-With": null
          },
        },
        editorOption: {
          placeholder: 'Nhập văn bản ở đây',
        },
      };
    },
    computed: {
      ...mapState([
        'system', 
        'config'
      ]),
      apiBaseUrl() {
        return this.config.beUrl;
      }
    },
    created(){
      this.dropzoneOptions.url = `${this.apiBaseUrl}/api/v1/public/images`;
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      resetForm(){
        this.form = {
          name: null,
          email: null,
          phone: null,
          title: null,
          message: null,
          images: []
        };
        this.$refs.contactForm.reset();
        this.$refs.contactForm.resetValidation();
      },
      send() {
        let method = "post";
        let url = `api/v1/public/contacts`;
        this.form.images = this.images;
        
        axios[method](url, this.form)
          .then((response) => {
            if(response.status == 200){
              this.success=true;
              this.resetForm();
            }
          }).catch(function (error) {
            app.errors_exist = true;
            if(error.response.status === 422) {
              app.errors = error.response.data || {};
            }
          });
      },
      uploadSuccess(file, response) {
        this.openSnackbar({ 
          type: 'success',
          body: 'Tải tệp lên thành công!'
        });
        this.images.push(response.fileId);
      },
      uploadError(file, message) {
        console.log(message)
        this.openSnackbar({ type: 'error' });
      },
      fileRemoved(file, error, xhr) {
        file.previewElement.remove();
      },
      loadPictures() {
        this.dropzoneOptions.removeType = "client";
        this.$refs.myVueDropzone.removeAllFiles();
        this.dropzoneOptions.removeType = "server";
      }
    }
  };
</script>